import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { submitMountainData } from '../api/user';
import { useForm } from '../hooks/useForm';
import { MOUNTAIN_FIELDS } from '../utils/formConfig';
import { loadDropdownData, loadValidationRules } from '../utils/form';
import FormRenderer from '../components/FormRenderer';

const MountainForm = forwardRef(({ token, participantId, gender }, ref) => {
  const [loading, setLoading] = useState(false);

  const {
    formData,
    handleChange,
    dropdowns,
    fieldErrors,
    isComplete,
    isValid,
    loading: dataLoading,
    errors: formError
  } = useForm({
    initialFields: MOUNTAIN_FIELDS,
    loadDropdowns: loadDropdownData,
    loadRules: loadValidationRules,
    gender
  });

  useImperativeHandle(ref, () => ({
    async submit() {
      if (!isComplete || !isValid) {
        throw new Error('Formulario incompleto o inválido');
      }

      const payload = {
        registration_token: token,
        participant_id: participantId,
        ...formData
      };
      console.log("InsideMountainForm")
      console.log("Participant ID", participantId)
      setLoading(true);
      try {
        return await submitMountainData(payload);
      } finally {
        setLoading(false);
      }
    }
  }));

  if (dataLoading) return <p>Loading form data...</p>;
  if (formError) return <p>Error loading form</p>;

  return (
    <>
      <FormRenderer
        fields={MOUNTAIN_FIELDS}
        formData={formData}
        errors={fieldErrors}
        handleChange={handleChange}
        // loading={loading}
        dropdowns={{
          discipline: dropdowns.discipline_choices,
          skill_level: dropdowns.skill_level_choices,
          height_cm: dropdowns.height_choices,
          weight_kg: dropdowns.weight_choices,
          shoe_size: dropdowns.shoe_size_choices
        }}
        columns={2}
        // showButtons={false}
      />
    </>
  );
});

export default MountainForm;
